export default {
    init() {
    },
    finalize() {

        jQuery('#password_1').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#password_1").keyup(function(e){

            window.checkPasswordStrength(jQuery(this),jQuery('#password_strength'), [], jQuery('form.lost_reset_password button'), true );

        });

        jQuery.ajax( {
            url: ew.wc_ajax_url.toString().replace( '%%endpoint%%', 'ew_create_pass_reset_nonce' ),
            type: 'POST',
            data: {},
            success: function (response) {
                jQuery('input[name="woocommerce-lost-password-nonce"]').val(response);
            }
        } );
    }
};



// WEBPACK FOOTER //
// ./js/routes/woocommerce-account-lost-password.js